import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

/**
 * 회사 관리자가 사용자를 초대
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/invitation-controller/inviteUser
 * @param payload  email
 * @returns
 */
export function invite(companyId: string, payload: { email: string }) {
  return API.post<ResponseBaseWithData>(`/api/v3/companies/${companyId}/invitations`, {
    data: payload,
  });
}

export function inviteMemberBulk(
  companyId: string,
  payload: { invitations: Array<{ email: string; roleId: number }> },
) {
  return API.post<ResponseBaseWithData>(`/api/v3/companies/${companyId}/invitations/email/bulk`, {
    data: payload,
  });
}

export interface InviteLinkItem {
  id: number;
  link: string;
  expiredAt: string;
  roleId: number | null;
}

export function getInviteLink(companyId: string) {
  return API.get<ResponseBaseWithData<InviteLinkItem[]>>(
    `/api/v3/companies/${companyId}/invitations/link`,
  );
}

export function createInviteLink(companyId: string, roleId: number) {
  return API.post<ResponseBaseWithData<InviteLinkItem>>(
    `/api/v3/companies/${companyId}/invitations/link`,
    {
      data: {
        roleId,
      },
    },
  );
}

export type Invited = {
  id: number;
  guestEmail: string;
  sentAt: string;
  expiredAt: string;
  roleId: number | null;
};
export interface InvitedMembersResponse extends ResponseBaseWithData {
  data: Invited[];
}
/**
 * 초대된 구성원들 조회
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/invitation-controller/getInvitationList
 * @param companyId
 * @returns
 */
export function getInvitedByEmailMembers(companyId: string) {
  return API.get<InvitedMembersResponse>(`/api/v3/companies/${companyId}/invitations/email`);
}

export function cancelInvitation(companyId: string, invitationId: number) {
  return API.delete<ResponseBaseWithData>(
    `/api/v3/companies/${companyId}/invitations/${invitationId}`,
  );
}

export function updateInviteRole(companyId: string, invitationId: number, roleId: number) {
  return API.put<ResponseBaseWithData>(
    `/api/v3/companies/${companyId}/invitations/${invitationId}/role`,
    {
      data: {
        roleId,
      },
    },
  );
}
